import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { UserService } from 'services/user.service';
import { ApplicationService } from 'services/application.service';
import { AlertService } from 'services/alert.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { NavigationService } from 'services/navigation.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cancellationofservice',
  templateUrl: './cancellationofservice.component.html',
  styleUrls: ['./cancellationofservice.component.scss']
})
export class CancellationofserviceComponent implements OnInit {
  form: FormGroup;
  srcApplicationList: any[];
  applicationList: any[];
  cancellationTypeList: any[];
  dropdownSettings = {};
  cancellationDetails = {
    referenceNumber: '',
    productName: '',
    monthlyFees: '',
    address: '',
    cancellationDate: '',
    reasonType: '',
    comments: ''
  };
  min: Date;
  max: Date;

  showDetails = false;

  public myFilter = (d: Date): boolean => {
    // const day = d.getDay();
    // // Prevent Saturday and Sunday from being selected.
    // return day !== 0 && day !== 6;

    // const day = d.getDay();
    // // Prevent Saturday and Sunday from being selected.
    // return day !== 0 && day !== 6;

    const date = d.getDate();

    this.form.value.cancellationDate = this.transformDate(d);

    return date == 1;
  }
  mindate: Date;
  maxdate: Date;
  isRecurringProduct: boolean;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private applicationService: ApplicationService,
    private alertService: AlertService,
    private datePipe: DatePipe,
    public navigationService: NavigationService,
    private router: Router,) {
    this.initializeValidators();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'Un Select All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };


  }



  ngOnInit() {

    var newDate = new Date();
    newDate.setMonth(newDate.getMonth() + 2);
    var date = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
    this.min = date;


    this.getApplicationList(false);
    this.getCancellationType(false);
  }

  getApplicationList(refresh) {
    this.userService.getApplicationList(refresh).subscribe(result => {

      this.srcApplicationList = [];
      this.applicationList = [];
      this.srcApplicationList = result;
      var keyValue = 0;

      this.srcApplicationList.forEach(applicationItem => {
        if (applicationItem.vumatelNetworkIdentifier) {
          this.applicationList.push({ key: keyValue, value: applicationItem.referenceNumber });
          keyValue = keyValue + 1;
        }
      });
    });
  }

  transformDate(date) {
    return this.datePipe.transform(date, 'yyyy/MM/dd');
  }


  getCancellationType(refresh) {
    this.applicationService.getVematelCancellationType(refresh).subscribe(result => {
      this.cancellationTypeList = [];
      this.cancellationTypeList = result;
    });
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      application: [''],
      cancellationDate: ['', [Validators.required]],
      reasonType: ['', [Validators.required]],
      comments: ['', [Validators.required]]
    });
  }

  onSubmit() {
    if (this.form.value.application.value) {
      this.applicationService.getCustomerInfoForCancellation(this.form.value.application.value).subscribe(response => {
        this.cancellationDetails = response;
        var d = new Date();
        var date = d.getDate();
        if (response.daysOfDebit != null) {

          this.isRecurringProduct = true;

          var debitDays = response.daysOfDebit == 1 ? 1 : response.daysOfDebit == 2 ? 16 : response.daysOfDebit == 3 ? 21 : 26;
          if (date > debitDays) {
            d = new Date(d.getFullYear(), d.getMonth() + 1, debitDays);
            this.mindate = d;
            this.maxdate = d;
          }
          else {
            d = new Date(d.getFullYear(), d.getMonth(), debitDays);
            this.mindate = d;
            this.maxdate = d;
          }
        }
        else {
          d = new Date(d.getFullYear(), d.getMonth(), date + 1);
          this.mindate = d;
          this.maxdate = d;
          this.isRecurringProduct = false;
        }


        if (response && response.referenceNumber) {
          this.showDetails = true;
        }
        else {
          this.showDetails = false;
          this.alertService.warning('No Record Found!');
        }
      });
    }
    else {
      this.alertService.warning('Please Select Application');
    }
  }

  submitCancellation() {
    if (this.form.valid) {

      //this.cancellationDetails.cancellationDate = this.form.value.cancellationDate;

      //   var cancellationRequest = {
      //     cancellationDate: this.form.value.cancellationDate,
      //     reasonType: this.form.value.reasonType,
      //     comments: this.form.value.comments,
      //     referenceNumber : this.form.value.application.value
      // };

      //this.cancellationDetails.cancellationDate = this.transformDate(this.form.value.cancellationDate);

      this.cancellationDetails.cancellationDate = moment(this.form.value.cancellationDate).format('YYYY-MM-DD HH:mm:ss');
      this.cancellationDetails.reasonType = "{\"key\":\"" + this.form.value.reasonType.key + "\",\"value\":\"" + this.form.value.reasonType.value + "\"}";
      this.cancellationDetails.comments = this.form.value.comments;

      this.applicationService.saveCustomerCancellation(this.cancellationDetails).subscribe(response => {
        if (!response) {
          this.showDetails = true;
          // this.alertService.success("Cancellation Requested");
          swal.fire({
            text: "Cancellation Requested",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then((res) => {
            if (res.value) {
              this.navigationService.goToDashboard();
            }
          });
        }
        else {
          this.showDetails = false;

          if (response.detail) {
            swal.fire({
              title: 'Oops! Something went wrong',
              //  html:  +result.value.vumatelApiErrorMessage ,                   
              text: response.detail,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#d33',
              confirmButtonText: 'Ok',
            }).then((res) => {
              if (res.value) {
                this.navigationService.goToDashboard();
              }
            });
            // this.alertService.warning(response.detail);
          }
          else if (response) {
            swal.fire({
              title: 'Oops! Something went wrong',
              //  html:  +result.value.vumatelApiErrorMessage ,                   
              text: response,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#d33',
              confirmButtonText: 'Ok',
            }).then((res) => {
              if (res.value) {
                this.navigationService.goToDashboard();
              }
            });
            // this.alertService.warning(response);
          }

        }
      });
    }
    else {
      this.validateFormControl();
      this.alertService.warning('Please fill Required field');
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
}
